import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ActionsTable } from "Common/Components";
import { useSessionStore } from "Common/Stores";
import { Correlative } from "interfaces";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getBranchesByCompany, getCorrelativesByBranch, removeCorrelaitve } from "services";
import { useCorrelativeStore } from "../store/useCorrelativeStore";
import { NotificationType, showNotifications } from "helpers/toas_notification";

export const useCorrelativeList = () => {
  const { session } = useSessionStore();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const [company, setCompany] = useState<string>("");



  const {
    idDelete,
    setIsEdith,
    setIdDelete,
    setCorrelative,
    setOptionBranch,
    optionBranch,
    idBranch,
    setIdBranch
  } = useCorrelativeStore();
  const [correlativeRows, setCorrelativeRows] = useState<any[]>([]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);


  let branchSelected = session?.employe.branch.id ?? null;

  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: t("correlativeScreen.table.description"),
      accessorKey: "description",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: t("correlativeScreen.table.actions"),
      accessorKey: "actions",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ getValue }: { getValue: () => any }) => getValue(),
    },
  ];

  useEffect(() => {
    if (session?.employe) {
      setCompany(session.employe.branch.company.id.toString());
    }
  }, [session?.employe]);


  const { data: branchs, refetch: refetchBranch } = useQuery({
    queryKey: ["branch", company],
    queryFn: () => getBranchesByCompany(company),
    enabled: Boolean(company),
  });

  useEffect(() => {
    if (branchs) {
      const options = branchs.data.map(branch => ({
        label: branch.description,
        value: branch.id.toString(),
      }));
      setOptionBranch(options);

    }
  }, [branchs]);

  const {
    data: correlatives,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["correlatives", branchSelected],
    queryFn: () => {
      return getCorrelativesByBranch(branchSelected?.toString()!);
    },
    enabled: !!branchSelected,
  });

  useEffect(() => {
    if (correlatives) {
      const activeCorrelatives = correlatives.filter(c => c.state === 1);
      setCorrelativeRows(createCorrlativeRows(activeCorrelatives));
    }
  }, [correlatives]);


  const onhandleCreateEmploye = () => {
    setShowCreateModal(true);
  };

  const createCorrlativeRows = (correlatives: Correlative[]) => {
    return correlatives.map((correlative, index) => ({
      ID: index + 1,
      description: correlative.correlative,
      actions: (
        <ActionsTable
          onClickDelete={() => handleDeleteModal(correlative.id)}
          onClickEdith={() => handleEditModal(correlative)}
        ></ActionsTable>
      ),
    }));
  };

  const handleEditModal = (correlative: Correlative) => {
    setCorrelative(correlative);
    setIsEdith(true);
    setShowCreateModal(true);
  };

  const handleDeleteModal = (correlativeId: number) => {
    setShowDeleteModal(true);
    setIdDelete(correlativeId);
  };

  const onHideModal = () => {
    setShowDeleteModal(false);
    setIdDelete(0);
  };

  const onHideCreateEdithModal = () => {
    setShowCreateModal(false);
    setCorrelative(null);
    setIsEdith(false);
  };

  const onDeleteConfirm = async () => {
    try {
      const responseDelete = await removeCorrelaitve(idDelete);

      if (responseDelete.code === "200") {
        queryClient.invalidateQueries({
          queryKey: ["correlatives", branchSelected],
        });
        onHideModal();
        showNotifications(
          NotificationType.SUCCESS,
          t("deleteModal.succedDelete")
        );
      } else {
        showNotifications(
          NotificationType.ERROR,
          t("deleteModal.errorDelete" + responseDelete.message)
        );
      }
    } catch (error) {
      showNotifications(NotificationType.ERROR, t("deleteModal.errorDelete"));
    }
  };

  return {
    session,
    branchSelected,
    columns,
    correlativeRows,
    showDeleteModal,
    showCreateModal,
    onhandleCreateEmploye,
    onHideModal,
    onDeleteConfirm,
    onHideCreateEdithModal,
    idBranch,
    optionBranch,
    setIdBranch,
  };
};
